import { m } from 'framer-motion';
import { FC, useState } from 'react';
import Plus from '@components/Icons/Plus';

import s from './AddButton.module.scss';

const MotionPlus = m.create(Plus);

const AddButton: FC<{
  onClick: () => void;
  label: string;
}> = ({ onClick, label }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <m.button
      layout="size"
      onClick={onClick}
      className={s.addButton}
      onHoverStart={() => setHovered(true)}
      onHoverEnd={() => setHovered(false)}
      transition={{ duration: 0.1 }}
    >
      <MotionPlus layout="size" size={12} />
      {hovered && <m.span layout="size">{label}</m.span>}
    </m.button>
  );
};

export default AddButton;
